import ProviderImg from 'src/assets/Buy_Policy_Images/digitVector.svg'

export const POLICY_STATUS_SMALLCASE = {
  EXPIRED: 'expired',
}

export const COMMITMENT_FOR_ROAD_SAFETY =
  'Your commitment promotes road safety for all. Keep up the great work! '

export const NO_ADDONS = 'No Addons available'

export const ERROR_ON_ADDONS_LIST =
  'Encountered an error while fetching addOns list.'

export const FILL_VEHICLE_DETAILS = 'Please fill vehicle details'

export const VEHICLE_DETAILS = {
  BRAND: 'brand',
  MODEL: 'model',
  VARIANT: 'variant',
  FUELTYPE: 'fuelType',
}

export const FORMIK_KEYS = {
  EXPIRYDATE: 'expiryDate',
  POLICYTYPE: 'policyType',
  EXPIRY_DATE_SHOULD_BE_GREATER:
    'Third Party Expiry Date should be greater than Previous Policy Expiry Date',
}

export const thirdPartyPlans = [
  {
    provider: 'digit',
    logo: ProviderImg,
    price: '12800',
  },
  {
    provider: 'digit',
    logo: ProviderImg,
    price: '100',
  },
  {
    provider: 'digit',
    logo: ProviderImg,
    price: '1900',
  },
  {
    provider: 'digit',
    logo: ProviderImg,
    price: '1200',
  },
  {
    provider: 'digit',
    logo: ProviderImg,
    price: '1000',
  },
  {
    provider: 'digit',
    logo: ProviderImg,
    price: '19000',
  },
]
